import { List, ListItem, ListItemText, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Popup from '@ivorobioff/shared/modal/components/Popup';
import useService from '@ivorobioff/shared/ioc/useService';
import { NoteService } from '../../../services/NoteService';
import { of as observable } from 'rxjs';

interface PredefinedNoteSelectProps {
  planId: string;
  onSelect: (note: string) => void;
  onClose: () => void;
}

export default function PredefinedNoteSelect({ planId, onSelect, onClose }: PredefinedNoteSelectProps) {
  const noteService = useService(NoteService);
  const [notes, setNotes] = useState<string[]>([]);
  const [other, setOther] = useState('');

  useEffect(() => {
    (async () => {
      setNotes(await noteService.getAll(planId));
    })();
  }, [planId]);

  const customNote = other.trim();

  return (
    <Popup
      open
      title="Select a Note"
      onClose={onClose}
      submitButtonTitle={customNote ? 'Submit' : 'Close'}
      onHandle={customNote ? () => {
        onSelect(other.trim());
        return observable(undefined);
      } : undefined}
    >
      <List disablePadding>
        {notes.map(note => (
          <ListItem button key={note} onClick={() => onSelect(note)}>
            <ListItemText primary={note} />
          </ListItem>
        ))}
        <ListItem>
          <TextField
            fullWidth
            placeholder="Other"
            value={other}
            onChange={e => setOther(e.target.value)}
          />
        </ListItem>
      </List>
    </Popup>
  );
}
